allow-visible-on-all-workspaces:
  title: 跨桌面可見性
  description: 允許視窗在所有虛擬桌面中可見，僅限 macOS。
pages:
  modules:
    mcp-server:
      description: 連線與管理 MCP 伺服器和工具
      title: MCP 伺服器
  system:
    sections:
      section:
        window-shortcuts:
          title: 鍵盤快捷鍵
    window-shortcuts:
      description: 修改視窗快捷方式
      title: 視窗快捷方式
      toggle-move:
        label: 切換移動狀態
      toggle-resize:
        label: 調整大小
      toggle-ignore-mouse-event:
        label: 忽略滑鼠事件
      press-keys: 請按下按鍵...
    developer:
      sections:
        section:
          use-window-mouse:
            title: useWindowMouse
            description: Test the Electron window cursor position
devtools:
  title: 開發者
  pages:
    context-flow:
      title: Context Flow
    lag-visualizer:
      title: Lag Visualizer
    performance-visualizer:
      title: Performance Visualizer
      description: Toggle FPS/long task/memory overlay
    markdown-stress:
      title: Markdown Stress
      description: Stress markdown parsing and rendering with heavy chat payloads
    widgets-calling:
      title: Widget Calling
screen-capture:
  permissions-prompt:
    title: Screen Capture
    description: To capture screens or windows, screen and system audio recording permissions are required.
    open-preferences: Open System Preferences
    dismiss: Dismiss
    instructions:
      step-1: Open "System Preferences", select "Privacy & Security" from the sidebar.
      step-2: In the "Screen & System Audio Recording" and "System Audio Recording Only" sections, turn on the switches for AIRI.
      step-2-note: If AIRI is not listed, please add it manually by clicking the "+" button and selecting AIRI from the Applications folder.
